import React from 'react';
import { connect } from 'react-redux';
import { Component } from 'react';
import { bindActionCreators } from 'redux';
import cryptoJS from 'crypto-js';
import { goToErrorsView, recordAndSavePage } from 'actions/errorViewNavigation';
import stepsActions from 'actions/stepsActions';
import { actions as formActions } from 'react-redux-form';
import preLoaderActions from 'actions/preLoaderActions';
import apiURLBuilder from 'core/apiURLBuilder';
import { getLanguage, formatText } from 'core/i18n';
import Storage from 'utilities/storage';
import { LoginModal } from 'components/commons/loginForm/LoginModal';
import { PUBLICA_URL } from 'constants/index';
import { PATH_JOINHOLDER_LOGIN } from 'constants/uTagConstants/paths';
import UtagHelper from 'utilities/utagHelper';
import { recordEvent, recordedInitialPage, PAGE_PRODUCT } from 'utilities/uTagging';

class JointLogin extends Component {
    componentDidMount() {
        const { userProfile, recordAndSavePage } = this.props;
        const docNumberEncrypted = userProfile.docNumber ? cryptoJS.SHA256(userProfile.docNumber).toString() : '';
        if (userProfile.jointHolderData) {
            const invite = userProfile.jointHolderData.invite;
            const JointHolderInfo = UtagHelper.getJointHolderInfoFromInvite(invite, 'cliente');
            const productDescription = userProfile.jointHolderData.accountOwner.accountType;
            recordAndSavePage(
                PATH_JOINHOLDER_LOGIN,
                '',
                '',
                userProfile.product,
                productDescription,
                invite.promoCode,
                JointHolderInfo,
                '',
                '',
                userProfile.investmentType,
                {
                    identificadorOnboarding: docNumberEncrypted,
                }
            );
        }
    }

    handleLoginSuccess = response => {
        const { userProfile, immOptions, preLoaderActions, stepsActions } = this.props;
        const { docNumber } = userProfile;
        const docNumberEncrypted = docNumber ? cryptoJS.SHA256(docNumber).toString() : '';
        Storage.cookies.remove('jointHolderInvite');
        preLoaderActions.showPreLoader();
        const professionalCategories = immOptions.get('professionalCategories');
        stepsActions.getInformationByTokenPrivate(response.token, professionalCategories, false);
        recordedInitialPage();
        recordEvent(
            PATH_JOINHOLDER_LOGIN,
            PAGE_PRODUCT,
            'exito',
            '',
            '',
            '',
            '',
            userProfile.investmentType,
            docNumberEncrypted
        );
    };

    handleLinkClick = () => {
        if (getLanguage() === 'es') {
            window.open(`${PUBLICA_URL}/he-olvidado-mi-clave`, '_blank');
        } else {
            window.open(`${PUBLICA_URL}/i-forgot-my-password`, '_blank');
        }
    };

    handleLoginError(params) {
        const { userProfile, formActions, goToErrorsView } = this.props;
        const { docNumber } = userProfile;
        const docNumberEncrypted = docNumber ? cryptoJS.SHA256(docNumber).toString() : '';
        recordEvent(
            PATH_JOINHOLDER_LOGIN,
            PAGE_PRODUCT,
            'error',
            '',
            '',
            '',
            '',
            userProfile.investmentType,
            docNumberEncrypted
        );
        if (params.error.body.error === '8002') {
            formActions.change('userProfile.errorIconClass', 'icons icons--icon-warning');
            formActions.change('userProfile.name', userProfile.jointHolderData.invite.name);
            formActions.change(
                'userProfile.errorTitle',
                formatText('messagesScreen-onlyOneOnboardingErrorTitle', [userProfile.jointHolderData.invite.name])
            );
            formActions.change('userProfile.errorSubtitle', '');
            formActions.change('userProfile.buttonText', formatText('button-understood'));
            formActions.change('userProfile.buttonClass', 'form__button form__button-secondary');
            goToErrorsView({
                errorCode: params.error.body.error,
                errorMessage: 'messagesScreen-onlyOneOnboardingErrorContent',
                errorContent: 'messagesScreen-onlyOneOnboardingErrorContent',
            });
        }
    }

    render() {
        const { userProfile, show, onClose } = this.props;
        const payload = {
            force: true,
            inviteToken: userProfile.jointHolderInviteToken,
        };
        const url = apiURLBuilder.getURL('requestInviteeLogin');

        return (
            <LoginModal
                show={show}
                onClose={onClose}
                onLoginSuccess={this.handleLoginSuccess}
                onLinkClick={this.handleLinkClick}
                onLoginError={this.handleLoginError}
                payload={payload}
                url={url}
                version={0}
            />
        );
    }
}

module.exports.constructor = JointLogin;

module.exports.JointLogin = connect(
    state => ({
        immOptions: state.options,
        userProfile: state.userProfile,
    }),
    dispatch => ({
        stepsActions: bindActionCreators(stepsActions, dispatch),
        formActions: bindActionCreators(formActions, dispatch),
        preLoaderActions: bindActionCreators(preLoaderActions, dispatch),
        goToErrorsView: bindActionCreators(goToErrorsView, dispatch),
        recordAndSavePage: bindActionCreators(recordAndSavePage, dispatch),
    })
)(JointLogin);
